<template>
  <div class="page-container">
    <div v-if="termsAccepted">
      <h2 class="game-header">Welcome</h2>
      <p class="tandc-block">
        In The Detectives of Duskhelm, you become a notable character from the town of Duskhelm
        and try to solve some of the town's more perplexing conundrums, secrecies and crimes
        that have been presented before the Lord of the town.
      </p>
      <p class="tandc-block">
        Whether you choose to become the town's thief, the honorable member of the town's
        watch, the local monk or even the town's dunk, on offer is hefty bag of gold to any
        townsperson who can solve the mysteries.
      </p>
      <p class="tandc-block">
        You travel to key locations in Duskhelm, interrogate townsfolk and witnesses, piece
        together clues and information, and `importantly` try to sabotage your opponents
        from reaching the solution first by laying some wicked traps and obstacles across
        the town.
      </p>
      <router-link to="/start">Start</router-link>
    </div>
    <div v-else>
      <div v-html="termsHtml"></div>
      <button @click="acceptTerms">Accept</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      termsAccepted: false,
      termsHtml: '',
    };
  },
  mounted() {
    this.termsAccepted = window.localStorage.getItem('terms') === 'v1';
    if (!this.termsAccepted) {
      axios.get('/terms.html')
        .then((response) => {
          this.termsHtml = response.data;
        })
        .catch((err) => {
          this.termsHtml = err;
        });
    }
  },
  methods: {
    acceptTerms() {
      window.localStorage.setItem('terms', 'v1');
      this.termsAccepted = true;
    },
  },
};
</script>

<style>
.tandc-block {
  text-align: justify;
}
</style>
